import React, {Fragment} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "root/Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle, defaultTopLeftCellStyle, defaultTopRightCellStyle,
    TableActionIconDelete, TableActionIconEdit, TableActionIconView
} from "./BaseTableComponents";

import './Table.scss'

const DomainTable = (props) =>
{
    const onClickItem = (domain_id, mode) =>
    {
        props.clickHandler(domain_id, mode, props.onDialogClosed);
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        return (
            <Fragment>
                <TableActionIconDelete text="Delete Domain" onClick={() => onClickItem(row.domain_id, 'delete')} />
                <TableActionIconEdit text="Edit Domain Details" onClick={() => onClickItem(row.domain_id, 'edit')} />
            </Fragment>
        );
    }

    const leftHeaderStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        firstname: {borderRadius: defaultTopLeftCellStyle, width: "12vw"},
        surname: {width: "10vw"},
        name: {width: "10vw"},
        view: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "6vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "domain_name",
                text: "Name",
                sort: true,
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "description",
                text: "Description",
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "view",
                formatter: linkFormatter,
                align: 'right',
                text: "Manage",
                headerStyle: leftHeaderStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
    };

export default DomainTable;

DomainTable.propTypes = {
    family_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};